export const ApplicationStatusMap: Map<number, string> = new Map();
ApplicationStatusMap.set(0, 'assistance-required');
ApplicationStatusMap.set(1, 'start-application');
ApplicationStatusMap.set(2, 'personal-details');
ApplicationStatusMap.set(3, 'consent');
ApplicationStatusMap.set(4, 'idv-check');
ApplicationStatusMap.set(5, 'bank-list');
ApplicationStatusMap.set(6, 'connected-accounts');
ApplicationStatusMap.set(7, 'bwa-check');
ApplicationStatusMap.set(8, 'account-requirement-check');
ApplicationStatusMap.set(9, 'all-done');
ApplicationStatusMap.set(10, 'affordability-passport');
ApplicationStatusMap.set(19, 'pay-data-not-available');
ApplicationStatusMap.set(20, 'pay-data-available');

export const CompletedApplicationStatus: Map<number, string> = new Map();
CompletedApplicationStatus.set(9, 'all-done');
CompletedApplicationStatus.set(10, 'affordability-passport');
CompletedApplicationStatus.set(19, 'pay-data-not-available');
CompletedApplicationStatus.set(20, 'pay-data-available');
